import React from 'react';
import LouiseTrinitIA from '../components/LouiseTrinitIA';

const LouiseTrinitIAPage = () => {
  return (
    <div>
      <LouiseTrinitIA />
    </div>
  );
};

export default LouiseTrinitIAPage;
